import React, { useRef, useState } from "react";
import TableCell from "@material-ui/core/TableCell";
import cn from "classnames";
import IconButton from "../../icon-button";
import { FormattedMessage } from "react-intl";
import Icon from "../../icon";
import { TableIconCell, CustomTableRow } from "../../table";
import OptionalDate from "../../optional-date";
import PropTypes from "prop-types";
import { injectIntl } from "react-intl";
import withStyles from "../../with-styles";
import styles from "./styles.css.js";
import { eventStatusTypes } from "../../../pages/event";
import Tooltip from "@material-ui/core/Tooltip";
import { getRecordingClipsService } from "../../../services/commonService";
import ApiConnectedPaginatedTable from "../../table/paginated-table/api-connected-paginated-table";
import DownloadIcon from "../../buttons/download-button/parts/download-icon";
import ShareUrlDialog from "./partial/share-url-dialog";
import PlayerDialog from "../player-dialog/player-dialog";

const Header = () => {
  return <></>;
};

const StyledHeaderComponent = withStyles(styles)(Header);

const RowComponent = ({ item, classes, intl }) => {
  const [shareDialog, setShareDialog] = useState(false);
  const [displayPlayer, setDisplayPlayer] = useState(false);

  const linkDisabled = item.event && item.event.eventStatus && item.event.eventStatus === eventStatusTypes.STARTED;

  const handlerCopyToClipboard = (data, event) => {
    event.stopPropagation();
    navigator.clipboard.writeText(data?.url);
  };

  const handleDownload = (data, event) => {
    event.stopPropagation();
    window.location.href = data.url;
  };

  const handleShareDialog = event => {
    event.stopPropagation();
    setShareDialog(shareDialog => !shareDialog);
  };

  const handlePlayer = () => {
    setDisplayPlayer(displayPlayer => !displayPlayer);
  };

  return (
    <>
      <ShareUrlDialog intl={intl} handleClose={handleShareDialog} open={shareDialog} clip={item} />
      <PlayerDialog intl={intl} handleClose={handlePlayer} open={displayPlayer} clip={item} />
      <CustomTableRow
        key={item.id}
        onClick={handlePlayer}
        disabled={linkDisabled}
        className={cn(classes.row, {
          [classes.main]: item.isMainEventRecording,
        })}
      >
        <TableCell width="60%">
          <div className={classes.title}>{item.title}</div>
          <div>{item.description}</div>
          <div>
            <OptionalDate className={classes.date} value={item.created_at * 1000} />
          </div>
        </TableCell>
        <TableCell width="20%">
          <>
            <div>
              <OptionalDate
                label={intl.formatMessage({ id: "event.startDate" })}
                className={classes.date}
                icon="event-available"
                value={item.start_time * 1000}
                showSeconds
              />
            </div>
            <div>
              <OptionalDate
                label={intl.formatMessage({ id: "event.endDate" })}
                className={classes.date}
                icon="event-available"
                value={item.start_time * 1000 + item.duration * 1000}
                showSeconds
              />
            </div>
          </>
        </TableCell>
        <TableIconCell width="20%">
          <>
            <Tooltip title={intl.formatMessage({ id: "recording.copyurl" })} arrow>
              <IconButton onClick={e => handlerCopyToClipboard(item, e)}>
                <Icon name="fileCopy" />
              </IconButton>
            </Tooltip>
            <Tooltip title={intl.formatMessage({ id: "common.download" })} arrow>
              <IconButton onClick={e => handleDownload(item, e)}>
                <DownloadIcon
                  compactStyle={true}
                  disabled={item.event_id === "continuous"}
                  disabledClass={classes.recording_download__main__disabled}
                />
              </IconButton>
            </Tooltip>
            <Tooltip title={intl.formatMessage({ id: "recording.share" })} arrow>
              <IconButton onClick={e => handleShareDialog(e)}>
                <Icon name="shareRoundedIcon" />
              </IconButton>
            </Tooltip>
          </>
        </TableIconCell>
      </CustomTableRow>
    </>
  );
};

RowComponent.propTypes = {
  /**
   ** Elemento a representar en la fila de la tabla
   **/
  item: PropTypes.object,
  /**
   ** Referencia con el último evento de la anterior grabación de la página
   **/
  previousEvent: PropTypes.object,
};

const StyledI18nRowComponent = withStyles(styles)(injectIntl(RowComponent));

const RecordingClipsPaginatedTable = ({ page, pageName, classes, ...props }) => {
  const previousEvent = useRef();

  const renderHeaderComponent = title => {
    return <StyledHeaderComponent title={title} />;
  };

  return (
    <>
      <div className={classes.titleTableContent}>
        <FormattedMessage id="app.page.clips" />
      </div>
      <ApiConnectedPaginatedTable
        APIPetition={getRecordingClipsService}
        headerComponent={() => renderHeaderComponent(props.variables.eventTitle)}
        rowComponent={StyledI18nRowComponent}
        paginatedElementsHandler={data => data}
        page={page}
        pageName={pageName}
        rowProps={{ previousEvent }}
        noDataMessage={"clips.no_data"}
        {...props}
      />
    </>
  );
};

RecordingClipsPaginatedTable.propTypes = {
  /**
   ** Página a cargar en la tabla
   **/
  page: PropTypes.number,
  /**
   ** Objeto que contiene los filtrados de la búsqueda
   **/
  variables: PropTypes.object,
  /**
   ** Componente que se mostrará en el pie de la tabla
   **/
  footer: PropTypes.element,
};

export default withStyles(styles)(RecordingClipsPaginatedTable);
